import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=0c8b2082&scoped=true&"
import script from "./topbar.vue?vue&type=script&lang=js&"
export * from "./topbar.vue?vue&type=script&lang=js&"
import style0 from "./topbar.vue?vue&type=style&index=0&id=0c8b2082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b2082",
  null
  
)

export default component.exports